//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import { queryFileList } from '@/api/api';
import pick from 'lodash.pick';
import { getAction } from '@/api/manage';
import JDate from '@/components/jeecg/JDate';
import JEditor from '@/components/jeecg/JEditor';
import SelectUserListModal from "./SelectUserListModal";
import { ACCESS_TOKEN } from '@/store/mutation-types';
import moment from 'moment';
import Vue from 'vue';
import IwsUpload from '@comp/upload/IwsUpload';
var columns3 = [{
  title: '排序',
  dataIndex: 'index',
  width: '5%',
  customRender: function customRender(t, r, index) {
    return parseInt(index) + 1;
  }
}, {
  title: '文件名称',
  dataIndex: 'fileName',
  width: '15%',
  scopedSlots: {
    customRender: 'fileName'
  }
}, {
  title: '文件大小',
  dataIndex: 'fileSize',
  width: '10%',
  scopedSlots: {
    customRender: 'fileSize'
  }
}, {
  title: '上传人',
  dataIndex: 'createBy',
  width: '10%',
  scopedSlots: {
    customRender: 'createBy'
  }
}, {
  title: '上传时间',
  dataIndex: 'createTime',
  width: '20%',
  scopedSlots: {
    customRender: 'createTime'
  }
}, {
  title: '操作',
  width: '10%',
  dataIndex: 'operation3',
  scopedSlots: {
    customRender: 'operation3'
  }
}];
var data3 = []; // PS相关的KEY不能为title关键字

export default {
  components: {
    JEditor: JEditor,
    JDate: JDate,
    SelectUserListModal: SelectUserListModal,
    IwsUpload: IwsUpload
  },
  name: 'SysAnnouncementModal',
  data: function data() {
    return {
      previewVisible: false,
      uploadFileList: [],
      //已经上传的文件列表
      previewImage: '',
      data3: data3,
      columns3: columns3,
      spinning: false,
      fileList: [],
      title: '操作',
      picUrl: '',
      uploadLoading: false,
      headers: {},
      visible: false,
      disableSubmit: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 14
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        title: {
          rules: [{
            required: true,
            message: '请输入标题!'
          }]
        },
        msgCategory: {
          rules: [{
            required: true,
            message: '请选择消息类型!'
          }]
        },
        msgType: {
          rules: [{
            required: true,
            message: '请选择通告对象类型!'
          }]
        },
        endTime: {
          rules: [{
            validator: this.endTimeValidate
          }]
        },
        startTime: {
          rules: [{
            validator: this.startTimeValidate
          }]
        }
      },
      url: {
        queryByIds: '/sys/user/queryByIds',
        add: '/sys/annountCement/add',
        edit: '/sys/annountCement/edit',
        getOne: '/sys/annountCement/queryById',
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      userType: false,
      userIds: [],
      selectedUser: [],
      disabled: false,
      msgContent: '',
      fileDelList: []
    };
  },
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    };
  },
  computed: {
    uploadAction: function uploadAction() {
      return this.url.fileUpload;
    } // uploadAction1: function () {
    //   console.log(222)
    //   return this.url.fileUpload;
    // }

  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      console.log(file);
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message_custom('请上传图片', 'warning');
        return false;
      } //TODO 验证文件大小

    },
    handleChange: function handleChange(info) {
      this.picUrl = '';

      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoading = false;

        if (response.success && response.result) {
          this.model.photo = response.result.id;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$message_custom(response.message, 'warning');
        }
      }

      this.fileList = info.fileList;
    },
    getAvatarView: function getAvatarView() {
      return this.url.imgerver + '/' + this.model.photo;
    },
    // 主要成分表格相关的操作函数

    /**/
    handleFileUpload: function handleFileUpload(info) {
      if (info.file.status === 'done') {
        var response = info.file.response;

        if (response.success) {
          console.log(response.result);
        } else {
          this.$message_custom(response.message, 'warning');
        }
      }

      this.uploadFileList = info.fileList;
    },
    //删除文件

    /* delTable3(key) {
        this.dataCommet = [];
        const newData = this.data3.filter(item => key != item.id)
        const docItem = this.data3.find(item => key == item.id);
        this.fileDelList.push(docItem);
        this.data3 = newData;
      },
      /!* 文件下载 *!/
      downUploadFile(text) {
        if (!text) {
          this.$message.warning("未知的文件")
          return;
        }
         window.open(window._CONFIG['domianURL'] + "/sys/common/file/download/" + text);
      },
      loadUploadFiles() {
        this.spinning = true;
        queryFileList("sys_announcement",this.model.id).then((res) => {
          console.log(res)
          this.spinning = false;
          if (res.result != null) {
            console.log(res)
            let docsList = [];
            for (let i = 0; i < res.result.length; i++) {
              let doc = res.result[i];
              doc.key = doc.id;
              docsList.push(doc);
            }
            this.data3 = docsList;
          }
        })
      },*/
    add: function add() {
      this.msgContent = '';
      this.data3 = [];
      this.uploadFileList = [];
      this.fileList = [], this.edit({});
    },
    edit: function edit(record) {
      this.data3 = [];
      this.uploadFileList = [];
      this.docDelList = [];
      this.form.resetFields();
      this.model = {};
      this.disable = false;
      this.visible = true;
      this.getOne(record);
    },
    getOne: function getOne(record) {
      var _this = this;

      this.model = Object.assign({}, record);

      if (typeof record.id != 'undefined') {
        // this.loadUploadFiles();
        this.$nextTick(function () {
          _this.$refs.iwupload.loadUploadFiles();

          _this.picUrl = 'Has no pic url yet';
        });
      }

      if (record.id) {
        getAction(this.url.getOne + '?id=' + record.id).then(function (res) {
          if (res.success) {
            _this.getUser(res.result);
          }
        });
      }
    },
    getUser: function getUser(record) {
      var _this2 = this;

      this.model = Object.assign({}, record);

      if (record.msgType === 'USER') {
        this.userType = true;
        this.userIds = record.userIds;
        getAction(this.url.queryByIds, {
          userIds: this.userIds
        }).then(function (res) {
          if (res.success) {
            for (var i = 0; i < res.result.length; i++) {
              _this2.selectedUser.push(res.result[i].realname);
            }

            _this2.$refs.UserListModal.edit(res.result, _this2.userIds);
          }
        });
      }

      this.$nextTick(function () {
        console.log(_this2.model);

        _this2.form.setFieldsValue(pick(_this2.model, 'endTime', 'startTime', 'titile', 'msgContent', 'sender', 'priority', 'msgCategory', 'msgType', 'sendStatus', 'delFlag'));
      });
    },
    close: function close() {
      this.$emit('close');
      this.selectedUser = [];
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var photo = that.model.photo;
          var httpurl = '';
          var method = '';

          if (!_this3.model.id) {
            httpurl += _this3.url.add;
            method = 'post';
          } else {
            httpurl += _this3.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this3.model, values);
          formData.photo = photo;

          if (_this3.userType) {
            formData.userIds = _this3.userIds;
          } // let sysFileList = [];
          //
          // if (this.uploadFileList != null) {
          //   for (let i = 0; i < this.uploadFileList.length; i++) {
          //     sysFileList.push({id: this.uploadFileList[i].response.result.id});
          //   }
          // }
          // formData.fileDelList = this.fileDelList;


          formData.msgCategory = '1';
          formData = _this3.$refs.iwupload.getUploadListToFromData(formData);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this3.$message_custom(res.message);

              _this3.$refs.iwupload.resetUploadFiles();

              that.$emit('ok');
            } else {
              _this3.$message_custom(res.message, 'warning');
            }
          }).finally(function () {
            that.confirmLoading = false;
            that.close();
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.visible = false;
      this.$emit('close');
      this.resetUser();
    },
    resetUser: function resetUser() {
      this.userType = false;
      this.userIds = [];
      this.selectedUser = [];
      this.disabled = false;
      this.$refs.UserListModal.edit(null, null);
    },
    selectUserIds: function selectUserIds() {
      this.$refs.UserListModal.add(this.selectedUser, this.userIds);
    },
    chooseMsgType: function chooseMsgType(value) {
      if ('USER' == value) {
        this.userType = true;
      } else {
        this.userType = false;
        this.selectedUser = [];
        this.userIds = [];
      }
    },
    // 子modal回调
    choseUser: function choseUser(userList) {
      this.selectedUser = [];
      this.userIds = [];

      for (var i = 0; i < userList.length; i++) {
        this.selectedUser.push(userList[i].realname);
        this.userIds += userList[i].id + ',';
      }
    },
    startTimeValidate: function startTimeValidate(rule, value, callback) {
      var endTime = this.form.getFieldValue('endTime');

      if (!value || !endTime) {
        callback();
      } else if (moment(value).isBefore(endTime)) {
        callback();
      } else {
        callback('开始时间需小于结束时间');
      }
    },
    endTimeValidate: function endTimeValidate(rule, value, callback) {
      var startTime = this.form.getFieldValue('startTime');

      if (!value || !startTime) {
        callback();
      } else if (moment(startTime).isBefore(value)) {
        callback();
      } else {
        callback('结束时间需大于开始时间');
      }
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};